import React from 'react';

import './style.scss';

const PopoverDivider = () => <li className="divider" />;

export default PopoverDivider;
